import { useSelector } from 'react-redux';

export const ValidarAltaAporte = (cuit) => {
    const {items} = useSelector((state)=> state.empresasPreafiliado)
    let estado = false;

    if(items.length!==0){
             for(let item2 of items){
                  if(item2.empresa!==null){
                    if(cuit===item2.empresa.cuit){
                         estado=true;
                       }
                  }
             }
     }
     return estado;
}